import React, { useContext, createContext, useState } from 'react';
import { EventsData } from 'components/LiveViewCollector/interface';

const useValue = () => {
  const [liveData, setLiveData] = useState<EventsData[]>([]);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [subscribedAgents, setSubscribedAgents] = useState<string[]>([]);
  return {
    liveData,
    setLiveData,
    isUnauthorized,
    setIsUnauthorized,
    subscribedAgents,
    setSubscribedAgents,
  };
};

const LiveData = createContext({} as ReturnType<typeof useValue>);

const LiveDataProvider = ({ children }: any) => {
  return <LiveData.Provider value={useValue()}>{children}</LiveData.Provider>;
};

const LiveDataContext = () => {
  return useContext(LiveData);
};

export { LiveDataProvider, LiveDataContext };
